import React, { useState, useRef, useEffect, Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { orderActions } from "../../../_store";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { fCurrency, fNumber } from "../../../utils/formatNumber";

const OrderDatatable = ({ orderId }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  let navigate = useNavigate();
  //#region -------------Reducer----------------------------
  const orderDetail = useSelector((state) => state.order.orderDetail);
  const listView = location.state;

  // #endregion ------------------  Reducer End --------------------------------

  //#region -------------useEffect----------------------------
  // use effect

  useEffect(() => {
    dispatch(orderActions.GetOrderDetailsByID({ OrderID: orderId }));
  }, [orderId]);

  // Product/Location sorting — same toggle cycle (asc -> desc -> unsorted)
  // and arrow icons as WeightVerification's Order Preparation table
  const [sortConfig, setSortConfig] = useState({
    key: "Location",
    direction: "asc",
  });

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, direction: "asc" };
      if (prev.direction === "asc") return { key, direction: "desc" };
      return { key: null, direction: "asc" };
    });
  };

  const sortedOrderProductModelList = useMemo(() => {
    const list = orderDetail?.OrderProductModelList
      ? [...orderDetail.OrderProductModelList]
      : [];
    if (!sortConfig.key) return list;
    return list.sort((a, b) => {
      const valA = (a[sortConfig.key] || "").toString().toLowerCase();
      const valB = (b[sortConfig.key] || "").toString().toLowerCase();
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [orderDetail, sortConfig]);

  const handlechanges = () => {
    navigate("/OrderList");
  };
  // #endregion ------------------End --------------------------------

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Product Details</h4>

          {Number(listView?.IsSkipBol) === 1 &&
            window.location.pathname !== "/ViewOrder" && (
              <Button
                style={{ float: "right" }}
                variant="btn btn-danger"
                onClick={handlechanges}
              >
                Back
              </Button>
            )}
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting_asc"
                      style={{
                        width: "177px",
                        textAlign: "left",
                        fontSize: 12,
                      }}
                    >
                      Category
                    </th>

                    <th
                      className="sorting"
                      style={{
                        width: "200px",
                        textAlign: "left",
                        fontSize: 12,
                      }}
                    >
                      Lot Number
                    </th>
                    <th
                      className="sorting"
                      style={{
                        width: "100px",
                        textAlign: "left",
                        fontSize: 12,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("Location")}
                    >
                      Location
                      {sortConfig.key === "Location" ? (
                        sortConfig.direction === "desc" ? (
                          <i className="fa fa-arrow-down" />
                        ) : (
                          <i className="fa fa-arrow-up" />
                        )
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="sorting"
                      style={{
                        width: "100px",
                        textAlign: "left",
                        fontSize: 12,
                      }}
                    >
                      SKU
                    </th>
                    <th
                      className="sorting"
                      style={{
                        width: "100px",
                        textAlign: "left",
                        fontSize: 12,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("ProductName")}
                    >
                      Product
                      {sortConfig.key === "ProductName" ? (
                        sortConfig.direction === "desc" ? (
                          <i className="fa fa-arrow-down" />
                        ) : (
                          <i className="fa fa-arrow-up" />
                        )
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="sorting"
                      style={{
                        width: "46px",
                        textAlign: "center",
                        fontSize: 12,
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      className="sorting"
                      style={{
                        width: "128px",
                        textAlign: "right",
                        fontSize: 12,
                      }}
                    >
                      Unit Price
                    </th>

                    <th
                      className="sorting"
                      style={{
                        width: "46px",
                        textAlign: "right",
                        fontSize: 12,
                      }}
                    >
                      Total
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {orderDetail &&
                    orderDetail.OrderProductModelList &&
                    // orderDetail.OrderProductModelList.map((obj, index) => (
                    //   <Fragment key={index}>
                    sortedOrderProductModelList.map((obj, index) => (
                      <Fragment key={obj.OrderProductID ?? index}>
                        <tr
                          className="odd"
                          role="row"
                          style={{
                            border: obj.IsReversed ? "2px solid red" : "none",
                            backgroundColor: obj.IsReversed
                              ? "#ffe6e6"
                              : "transparent",
                          }}
                        >
                          <td
                            style={{
                              maxWidth: 50,
                              textAlign: "left",
                              fontSize: 12,
                            }}
                            className="sorting_1"
                          >
                            {obj.CategoryName}
                          </td>
                          {/* <td style={{ maxWidth: 50, textAlign: "left" }}>
                            {obj.SubCategoryName}
                          </td> */}
                          <td
                            style={{
                              maxWidth: 10,
                              textAlign: "left",
                              fontSize: 12,
                            }}
                          >
                            {obj.LotNumber}
                          </td>
                          <td
                            style={{
                              maxWidth: 30,
                              textAlign: "left",
                              fontSize: 12,
                            }}
                          >
                            {obj.Location}
                          </td>
                          <td
                            style={{
                              maxWidth: 30,
                              textAlign: "left",
                              fontSize: 12,
                            }}
                          >
                            {obj.SKU}
                          </td>
                          <td
                            style={{
                              maxWidth: 50,
                              textAlign: "left",
                              fontSize: 12,
                            }}
                          >
                            {obj.ProductName}
                          </td>
                          <td style={{ textAlign: "center", fontSize: 12 }}>
                            {fNumber(obj.Quantity)}
                          </td>
                          <td style={{ textAlign: "right", fontSize: 12 }}>
                            {fCurrency(obj.UnitPrice)}
                          </td>

                          <td style={{ textAlign: "right", fontSize: 12 }}>
                            {fCurrency(obj.Total)}
                          </td>
                        </tr>
                      </Fragment>
                    ))}
                  <tr style={{ textAlign: "end" }} className="odd" role="row">
                    <td colSpan={8}>
                      {orderDetail.IsReversed ? (
                        <>
                          <b>Total : {fCurrency(orderDetail.GrandTotal)}</b>{" "}
                          <br />
                          <b>
                            Reversed Amount :{" "}
                            {fCurrency(orderDetail.ReversedAmount)}
                          </b>{" "}
                          <br />
                          <b>
                            Grand Total :{" "}
                            {fCurrency(
                              orderDetail.GrandTotal -
                                orderDetail.ReversedAmount,
                            )}
                          </b>
                        </>
                      ) : (
                        <b>Grand Total : {fCurrency(orderDetail.GrandTotal)}</b>
                      )}
                    </td>
                    {/* <td>{fCurrency(orderDetail.GrandTotal)}</td> */}
                  </tr>
                </tbody>
              </table>
              <br />
            </div>
          </div>
        </div>
        {/* <h4><b style={{ float: "right", padding: "0px 92px 0px 0px" }}>Grand Total : {fCurrency(orderDetail.GrandTotal)}</b></h4> */}
      </div>
    </div>
  );
};

export default OrderDatatable;
